import * as THREE from "three";

function add_grid(size, divisions) {
    return new THREE.GridHelper( size, divisions );
}

export { add_grid }
